// Approximate centre (governorate capital) for each Iraqi governorate, keyed by
// the lowercase English `state` value the order API returns. Used to centre the
// map on the right city when an order has no precise lat/lng (all 0,0 today).
export interface LatLng {
  latitude: number;
  longitude: number;
}

const GOVERNORATE_CENTRES: Record<string, LatLng> = {
  baghdad: { latitude: 33.3152, longitude: 44.3661 },
  basra: { latitude: 30.5085, longitude: 47.7835 },
  mosul: { latitude: 36.335, longitude: 43.1189 },
  babel: { latitude: 32.4817, longitude: 44.4203 },
  zeeqar: { latitude: 31.0434, longitude: 46.2574 },
  karbala: { latitude: 32.6167, longitude: 44.0245 },
  anbar: { latitude: 33.4206, longitude: 43.3073 },
  arbeel: { latitude: 36.1911, longitude: 44.0094 },
  diwania: { latitude: 31.9887, longitude: 44.9244 },
  najaf: { latitude: 31.9998, longitude: 44.3294 },
  simawa: { latitude: 31.3314, longitude: 45.281 },
  saladin: { latitude: 34.5953, longitude: 43.677 },
  maysan: { latitude: 31.8356, longitude: 47.1443 },
  dihok: { latitude: 36.8671, longitude: 42.948 },
  solaimania: { latitude: 35.5613, longitude: 45.4358 },
  karkok: { latitude: 35.4681, longitude: 44.3922 },
  diyala: { latitude: 33.7487, longitude: 44.6436 },
  koot: { latitude: 32.5126, longitude: 45.8181 },
};

export const getGovernorateCentre = (
  state: string | undefined | null
): LatLng | undefined => {
  if (!state) return undefined;
  return GOVERNORATE_CENTRES[state.trim().toLowerCase()];
};
